declare var swal: any;
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, ReadyForTransferBetweenDateController, ReadyForTransferBetweenDateRequest, CycleOocyteQualityBetweenDateController, CycleOocyteQualityBetweenDateRequest, IvfEmbryoTransferAttemptByCycleCodeController, IvfEmbryoTransferAttemptByCycleCodeRequest, SaveIvfEmbryoTransferAttemptRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, SingleWellCultureByCycleCodeController, SingleWellCultureByCycleCodeRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest, SaveCycleStatusRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, IvfCycleMembersListController, IvfCycleMembersListRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, IvfCycleEmbryoTransferredController, IvfCycleEmbryoTransferredRequest, SaveIvfCycleTestDataRequest, SaveIvfCycleMedicineDataRequest, FormOrganizer } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
//import { NgbTcDetailsModal } from '../tcdetails.modal';
//import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { NgbAddScanTestModal } from './addscantest.modal';
import { NgbAddScanMedicineModal } from './addscanmedicine.modal';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';
import { EtPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { NgbEditGradingetModal } from './editgradinget.modal';
import { NgbEditGradingFetModal } from './editgradingfet.modal';
import { NgbEditScanTestModal } from './editscantest.modal';
import { NgbEditScanMedicineModal } from './editscanmedicine.modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ivfetedit',
  templateUrl: './ivfetedit.component.html',
  styleUrls: ['./ivfetedit.component.scss'],
  animations: [routerTransition()]
})

export class IvfETEditComponent implements OnInit, AfterViewInit {

  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;

  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;

  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() CycleCode: number;
  @Input() Duration: number;
  @Input() FormattedCode: number;
  @Input() DisplayName: string;
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  TransferEndDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  TodayDate = new Date();
  public CanLoadReport: boolean = true;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;
  public PatientActorCode: number;
  public PatientCycleCode: number;

  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public ScanDetails: boolean = false;
  public Showpickup: boolean = true;
  public Showivf: boolean = false;
  public ReceipientActorCode: number;
  public TransferDateNew: Date;
  public ActivityCodenew: number;
  public displayPatientdata: boolean = true;
  public displayscansdata: boolean = false;
  //public ActivityCodeNew: number;
  CurrentSaveIvfCycleTestDataRequest: SaveIvfCycleTestDataRequest;
  CurrentSaveIvfCycleMedicineDataRequest: SaveIvfCycleMedicineDataRequest;
  //
  CurrentSaveCycleStatusRequest: SaveCycleStatusRequest;
  CurrentSaveIvfEmbryoTransferAttemptRequest: SaveIvfEmbryoTransferAttemptRequest;
  CurrentFdActorReportsDocController: FdActorReportsDocController[];
  CurrentFDActorDocRequest: FDActorDocRequest;

  LoadForms() {
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    this.CurrentFdActorReportsDocController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentFDActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFdActorReportsDocController();
  }
  public SelectedReport: string;
  public SelectedActorCode: number;
  GetFdActorReportsDocController() {
    this.StartRefreshing();

    this.CurrentFDActorDocRequest.ActorCode = 92;
    //this.CurrentFDActorDocRequest.ActorReportCode = null;
    //this.CurrentFDActorDocRequest.ActorReportTemplateCode = null;
    this.CurrentFDActorDocRequest.CreatedUserName = AppData.Instance().UserLoginDetails.DisplayName;
    this.CurrentFDActorDocRequest.ConditionalOperator = 11;
    //alert(this.FormattedCode);
    this.fdservice.GetFdActorReportsDocController(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFdActorReportsDocController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadPatients();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }



  //CurrentCycleOocyteQualityBetweenDateController: CycleOocyteQualityBetweenDateController[];
  //CurrentCycleOocyteQualityBetweenDateRequest: CycleOocyteQualityBetweenDateRequest;
  //LoadPatients2() {
  //  this.CurrentCycleOocyteQualityBetweenDateRequest = new CycleOocyteQualityBetweenDateRequest();
  //  //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
  //  this.CurrentCycleOocyteQualityBetweenDateRequest.FacilityCode = AppData.Instance().UserLoginDetails.EmpFacilityCode;
  //  //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
  //  this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;
  //  this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
  //  this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();
  //  //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
  //  //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
  //  //this.CurrentTreatmentCyclesRequest.From = 0;
  //  //this.CurrentTreatmentCyclesRequest.Status = "";
  //  this.CurrentCycleOocyteQualityBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
  //  this.GetCycleOocyteQualityBetweenDateController();
  //}

  //GetCycleOocyteQualityBetweenDateController() {
  //  this.StartRefreshing();


  //  this.actorservice.GetCycleOocyteQualityBetweenDateController(this.CurrentCycleOocyteQualityBetweenDateRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentCycleOocyteQualityBetweenDateController = this.ApiResData.Result;
  //        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
  //        //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
  //        //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
  //        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );
  //}
  CurrentReadyForTransferBetweenDateController: ReadyForTransferBetweenDateController[];
  CurrentReadyForTransferBetweenDateRequest: ReadyForTransferBetweenDateRequest;
  LoadPatients2() {
    this.CurrentReadyForTransferBetweenDateRequest = new ReadyForTransferBetweenDateRequest();

      this.CurrentReadyForTransferBetweenDateRequest.FacilityCode = AppData.Instance().SelectedBranchCode;

    this.CurrentReadyForTransferBetweenDateRequest.ConditionalOperator = 10;


    this.CurrentReadyForTransferBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentReadyForTransferBetweenDateController;
    this.GetReadyForTransferBetweenDateController();
  }
  GetReadyForTransferBetweenDateController() {
    this.StartRefreshing();
    this.CurrentReadyForTransferBetweenDateRequest.FromDate = new Date();
    this.CurrentReadyForTransferBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetReadyForTransferBetweenDateController(this.CurrentReadyForTransferBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentReadyForTransferBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentReadyForTransferBetweenDateController;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  constructor(private router: Router,
    public printService: PrintService, private spinner: NgxSpinnerService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
    private modalService: NgbModal, private parserFormatter: NgbDateParserFormatter, private filter: EtPipe) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {

    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    ///////////////////////
    this.LoadForms();
    this.LoadPatients2();
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
    this.PatientActorCode = this.ActorCode;
    this.PatientCycleCode = this.CycleCode;
    this.CurrentSaveIvfCycleTestDataRequest = new SaveIvfCycleTestDataRequest();
    this.CurrentSaveIvfCycleTestDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveIvfCycleMedicineDataRequest = new SaveIvfCycleMedicineDataRequest();
    this.CurrentSaveIvfCycleMedicineDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest = new SaveIvfEmbryoTransferAttemptRequest();
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveCycleStatusRequest = new SaveCycleStatusRequest();
    this.CurrentSaveCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.onSetFeatureAccessConfig();
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.CurrentActorProfileRequest = new ActorProfileRequest();
    this.CurrentActorProfileController = new ActorProfileController();
    if (this.NurseActorCode > 0) {
      this.CurrentActorProfileRequest.ActorCode = this.NurseActorCode;
    }
    else {
      this.CurrentActorProfileRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }
    this.CurrentActorProfileRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.ValueChangeActorPersonalInfoController = new ActorPersonalInfoController();
    this.ValueChangeActorImageController = new ActorImageController();
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }
  public viewmode: string = 'view';
  public fo: FormOrganizer;

  SetForm() {

    this.fo = new FormOrganizer();

    this.fo.Sections = new Array<SectionData>();
    var i = 0;
    while (i < this.FormData.length) {
      this.fo.Sections.push(this.FormData[i]);
      i++;
    }
    this.fo.Organize();
    //this.spinner.hide();
  }
  FormData: SectionData[];
  CurrentOTFormDetailByReportCodeController: OTFormDetailByReportCodeController[];
  CurrentOTFormDetailByReportCodeRequest: OTFormDetailByReportCodeRequest;
  LoadClinics(reportCode: string) {

    var r1: OTFormDetailByReportCodeRequest = new OTFormDetailByReportCodeRequest();
    r1.ConditionalOperator = 10;

    r1.PatientReportCode = this.Code;
    r1.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.GetOTFormDetailByReportCodeController(r1).subscribe
      ((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.stopRefreshing();
          //  this.CurrentOTFormDetailByReportCodeController = this.ApiResData.Result;
          //alert(this.CurrentOTFormDetailByReportCodeController);
          // var reportCode: number = this.CurrentOTFormsByFormattedCodeController[0].PatientReportCode;
          this.FormData = this.ApiResData.Result;
          this.SetForm();
          //if (this.FormData.length > 0)
          //  alert(this.FormData[0].Title);
          //else {
          //  alert("no data retrieved");
          //}



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }


  onAssignedToActorCode(event: any) {

    if (event != null) {
      //alert(this.SelectedReport);
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      //this.CurrentFdActorReportsDocController[0].TemplateName = event;
      // console.log('event--_>' + event);
      //   }
      this.Code = this.SelectedReport;
      this.LoadClinics(this.Code);
    }

  }

  ngAfterViewInit() {
    // pSteps.loadStep();
  }

  onSetFeatureAccessConfig() {


    //Features
    var PersonalInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_PersonalInfo.toUpperCase())
    var ContactInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ContactInfo.toUpperCase())

    //
    var Feature_NurseProfile_ProfileSummary = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileSummary.toUpperCase())
    var Feature_NurseProfile_JobPreferences = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_JobPreferences.toUpperCase())

    var Feature_NurseProfile_Education = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Education.toUpperCase())

    var Feature_NurseProfile_EmploymentHistory = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_EmploymentHistory.toUpperCase())

    var Feature_NurseProfile_References = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_References.toUpperCase())

    var Feature_NurseProfile_Identities = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Identities.toUpperCase())
    var Feature_NurseProfile_Certifications = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Certifications.toUpperCase())

    var Feature_NurseProfile_MedicalFitness = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_MedicalFitness.toUpperCase())

    var Feature_NurseProfile_ProfileImage = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileImage.toUpperCase())

    var Feature_NurseProfile_Legalinfo = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Legalinfo.toUpperCase())


    //

    if (PersonalInfo_FeaturesList.length > 0) {
      if (PersonalInfo_FeaturesList[0].Edit === true) {
        this.CanEditProfileInfo = 1;
      }
      if (PersonalInfo_FeaturesList[0].List === true) {
        this.CanShowProfileInfo = 1;
        //this.GetActorPersonalDetailInfoController();
      }
    }
    if (ContactInfo_FeaturesList.length > 0) {
      if (ContactInfo_FeaturesList[0].Edit === true) {
        this.CanEditContactInfo = 1;
      }
      if (ContactInfo_FeaturesList[0].List === true) {
        this.CanShowContactInfo = 1;
      }
    }

    //
    if (Feature_NurseProfile_ProfileSummary.length > 0) {
      if (Feature_NurseProfile_ProfileSummary[0].Edit === true) {
        this.CanEditProfileSummary = 1;
      }
      if (Feature_NurseProfile_ProfileSummary[0].List === true) {
        this.CanShowProfileSummary = 1;
      }
    }

    if (Feature_NurseProfile_JobPreferences.length > 0) {
      if (Feature_NurseProfile_JobPreferences[0].Edit === true) {
        this.CanEditJobPreferences = 1;
      }
      if (Feature_NurseProfile_JobPreferences[0].List === true) {
        this.CanShowJobPreferences = 1;
      }
    }

    if (Feature_NurseProfile_Education.length > 0) {
      if (Feature_NurseProfile_Education[0].Edit === true) {
        this.CanEditEducation = 1;
      }
      if (Feature_NurseProfile_Education[0].List === true) {
        this.CanShowEducation = 1;
      }
    }

    if (Feature_NurseProfile_EmploymentHistory.length > 0) {
      if (Feature_NurseProfile_EmploymentHistory[0].Edit === true) {
        this.CanEditEmploymentHistory = 1;
      }
      if (Feature_NurseProfile_EmploymentHistory[0].List === true) {
        this.CanShowEmploymentHistory = 1;
      }
    }

    if (Feature_NurseProfile_References.length > 0) {
      if (Feature_NurseProfile_References[0].Edit === true) {
        this.CanEditReferences = 1;
      }
      if (Feature_NurseProfile_References[0].List === true) {
        this.CanShowReferences = 1;
      }
    }

    if (Feature_NurseProfile_Identities.length > 0) {
      if (Feature_NurseProfile_Identities[0].Edit === true) {
        this.CanEditIdentities = 1;
      }
      if (Feature_NurseProfile_Identities[0].List === true) {
        this.CanShowIdentities = 1;
      }
    }

    if (Feature_NurseProfile_Certifications.length > 0) {
      if (Feature_NurseProfile_Certifications[0].Edit === true) {
        this.CanEditCertifications = 1;
      }
      if (Feature_NurseProfile_Certifications[0].List === true) {
        this.CanShowCertifications = 1;
      }
    }

    if (Feature_NurseProfile_MedicalFitness.length > 0) {
      if (Feature_NurseProfile_MedicalFitness[0].Edit === true) {
        this.CanEditMedicalFitness = 1;
      }
      if (Feature_NurseProfile_MedicalFitness[0].List === true) {
        this.CanShowMedicalFitness = 1;
      }
    }

    if (Feature_NurseProfile_ProfileImage.length > 0) {
      if (Feature_NurseProfile_ProfileImage[0].Edit === true) {
        this.CanEditProfileImage = 1;
      }
      if (Feature_NurseProfile_ProfileImage[0].List === true) {
        this.CanShowProfileImage = 1;
      }
    }

    if (Feature_NurseProfile_Legalinfo.length > 0) {
      if (Feature_NurseProfile_Legalinfo[0].Edit === true) {
        this.CanEditLegalinfo = 1;
      }
      if (Feature_NurseProfile_Legalinfo[0].List === true) {
        this.CanShowLegalinfo = 1;
      }
    }
    this.IsSetAccessRights = true;





    //
  }
  //var PatientActorCode = this.ActorCode;


  //AddDetails() {
  //  const modalRef = this.modalService.open(NgbTcDetailsModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })

  //}
  //AddEventDetails() {
  //  const modalRef = this.modalService.open(NgbEventAddModal,
  //    {
  //      centered: true

  //    })

  //}
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentReadyForTransferBetweenDateController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentReadyForTransferBetweenDateController,
          this.listFilter);
      }
    }
  }
  //

  //

  showPage(page: string) {
    this.currentPage = page;
  }
  BackToProfile() {
    alert("method");
    this.router.navigate(['testnurse/dashboard']);

  }
  BackToTreatment() {
    alert("Thistrearment");
    this.router.navigate(['testnurse/ivfdashboard']);
  }
  onClick() {
    let x = document.querySelector("#psa");
    if (x) {
      x.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  pickUp() {
    let y = document.querySelector("#pickup");
    if (y) {
      y.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  ET() {
    let z = document.querySelector("#et");
    if (z) {
      z.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  InsuminationLog() {
    let m = document.querySelector("#IL");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Grading() {
    let m = document.querySelector("#Grad");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  OQA() {
    let m = document.querySelector("#oqa");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  scans() {
    let m = document.querySelector("#scans");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  onpersonalInfoChange(event: any) {
    // console.log('onpersonalInfoChange');

    if (event != null) {

      this.ValueChangeActorPersonalInfoController = event;
      //console.log('this.ValueChangeActorPersonalInfoController.DisplayName--->' + this.ValueChangeActorPersonalInfoController.DisplayName);
      //this.ValueChangeActorPersonalInfoController.DisplayName = this.CurrentActorProfileController.DisplayName;
      if (this.ValueChangeActorPersonalInfoController.DisplayName != null) {
        this.CurrentActorProfileController.DisplayName = this.ValueChangeActorPersonalInfoController.DisplayName;
      }


    }

  }
  onactorImageInfoChange(event: any) {


    if (event != null) {

      this.ValueChangeActorImageController = event;

      if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
        //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

        this.CurrentActorProfileController.ActorImageFileUrl = this.ValueChangeActorImageController.ActorImageFileUrl;
      }


    }

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  closeResult: string;
  // This function is used in open
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })

  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}
  SelectedpatientDetails: ReadyForTransferBetweenDateController;

  Selectedpatient(objCategory: any) {
    var Patient: ReadyForTransferBetweenDateController = objCategory;
    if (Patient != null) {
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = Patient;
      this.ScanDetails = true;
      this.Loadmembers();
      this.LoadCycles();
      this.LoadEmbryoTransfer();
      this.LoadSingle();
      this.LoadPatients();
      this.CanLoadReport = true;
      this.LoadDropletEmbryoData();
      //this.LoadTestData();
      //this.LoadMedicineData();

      //this.LoadInsemination2();
      //this.LoadScansData();
      //this.LoadOvaryData();
      //this.LoadTestData();
      //this.LoadMedicineData();
    }

  }
  Selectedpatient2(objCategory: any) {
    var Patient: ReadyForTransferBetweenDateController = objCategory;
    if (Patient != null) {
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = Patient;
      //this.ScanDetails = true;
      this.displayPatientdata = false;
      this.displayscansdata = true;
      this.Loadmembers();
      this.LoadCycles();
      this.LoadEmbryoTransfer();
      this.LoadSingle();
      this.LoadPatients();
      this.CanLoadReport = true;
      this.LoadDropletEmbryoData();
      //this.LoadScansData();
      //this.LoadOvaryData();
      //this.LoadMasterReq();
      //this.LoadTestData();
      //this.LoadMedicineData();
      //this.LoadLmp()
    }
  }
  CurrentIvfCycleMembersListController: IvfCycleMembersListController[];
  Memberlist: IvfCycleMembersListController[];
  ReceipentMember: IvfCycleMembersListController[];
  CurrentIvfCycleMembersListRequest: IvfCycleMembersListRequest;
  Loadmembers() {
    this.CurrentIvfCycleMembersListRequest = new IvfCycleMembersListRequest();
    this.CurrentIvfCycleMembersListRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentIvfCycleMembersListRequest.ConditionalOperator = 10;
    this.CurrentIvfCycleMembersListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleMembersListController();
  }
  GetIvfCycleMembersListController() {
    //this.StartRefreshing();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetIvfCycleMembersListController(this.CurrentIvfCycleMembersListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentIvfCycleMembersListController = this.ApiResData.Result;
          // this.Memberlist = this.ApiResData.Result;
          var list = this.ApiResData.Result;
          list = list.filter(
            function (a) {
              return a.MemberType == "Recepient" && a.OwnerName != a.MemberDisplayName
            });
          if (list.length > 0) {
            this.ReceipentMember = list[0];
          }

          //this.Memberlist = list;
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfEmbryoTransferAttemptByCycleCodeController: IvfEmbryoTransferAttemptByCycleCodeController[];
  EmbryoTransFerEndInfo: IvfEmbryoTransferAttemptByCycleCodeController;
  CurrentIvfEmbryoTransferAttemptByCycleCodeRequest: IvfEmbryoTransferAttemptByCycleCodeRequest;
  LoadEmbryoTransfer() {
    this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest = new IvfEmbryoTransferAttemptByCycleCodeRequest();
    this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest.ConditionalOperator = 1;
    this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfEmbryoTransferAttemptByCycleCodeController();
  }
  GetIvfEmbryoTransferAttemptByCycleCodeController() {
    //this.StartRefreshing();


    this.actorservice.GetIvfEmbryoTransferAttemptByCycleCodeController(this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentIvfEmbryoTransferAttemptByCycleCodeController = this.ApiResData.Result;
          this.EmbryoTransFerEndInfo = this.CurrentIvfEmbryoTransferAttemptByCycleCodeController[0];
          this.TransferDateNew = this.EmbryoTransFerEndInfo.TransferDate;
          if (this.EmbryoTransFerEndInfo.TransferEndDate != null) {
            var SValidFrom = new Date(this.EmbryoTransFerEndInfo.TransferEndDate);
            if (SValidFrom.getFullYear() > 1900) {
              console.log('this.UpdateDate >1990');
              this.TransferEndDate = {

                year: SValidFrom.getFullYear(),
                month: SValidFrom.getMonth() + 1,
                day: SValidFrom.getDate()
              }
            }
          }
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
          //this.LoadActorCode();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentSingleWellCultureByCycleCodeController: SingleWellCultureByCycleCodeController[];
  CurrentSingleWellCultureByCycleCodeRequest: SingleWellCultureByCycleCodeRequest;
  LoadSingle() {

    this.CurrentSingleWellCultureByCycleCodeRequest = new SingleWellCultureByCycleCodeRequest();
    this.CurrentSingleWellCultureByCycleCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSingleWellCultureByCycleCodeRequest.ConditionalOperator = 10;
    this.CurrentSingleWellCultureByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetSingleWellCultureByCycleCodeController()
  }
  GetSingleWellCultureByCycleCodeController() {
    // this.StartRefreshing();


    this.actorservice.GetSingleWellCultureByCycleCodeController(this.CurrentSingleWellCultureByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentSingleWellCultureByCycleCodeController = this.ApiResData.Result;

          var list = this.CurrentSingleWellCultureByCycleCodeController.filter(
            function (a) {
              return a.IsTransferrable == true
            });

          this.CurrentSingleWellCultureByCycleCodeController = list;

          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
          //this.LoadActorCode();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  ActorDetails: TreatmentCyclesByActorCodeController;
  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadPatients() {
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    // this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.ActorDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
          this.ReceipientActorCode = this.ActorDetails.RecepientActorCode;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          // this.stopRefreshing();
          this.LoadMasterReq();
          this.LoadDSAData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  ActorCodeLoad() {
    //alert("ActorCode");
    var SelectedActorCode = this.ReceipientActorCode;
    return SelectedActorCode;
  }
  GetActorCode(EggSourceType: string): number {
    // alert("new");
    if (EggSourceType == 'Donor') {
      var DonorActorCode = this.ActorDetails.RecepientActorCode;
      return DonorActorCode;
    }
    else if (EggSourceType == 'Self') {
      var OwnerActorCode = this.ActorDetails.RecepientActorCode;
      return OwnerActorCode;
    }

  }
  CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
  DSADetails: DSAActivityByCycleCodeController;
  CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

  LoadDSAData() {
    //alert("ScansData")
    this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDSAActivityByCycleCodeController();
  }

  GetDSAActivityByCycleCodeController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
    this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
          this.DSADetails = this.GetCycleActivity2(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.SelectedpatientDetails.ProtocolStartDate)[0];
          //alert(this.DSADetails);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

          //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
          //var list = this.CurrentDSAActivityByCycleCodeController.filter(


          //    function (a) {
          //        var Date = this.FollicularScanEndInfo.ScanDate;
          //        var ActorCode = this.SelectedpatientDetails.ActorID;
          //        return a.ActivityDate == Date && a.ActorCode == ActorCode
          //    });

          //this.CurrentDSAActivityByCycleCodeController = list;
          //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
          //alert(this.Doc1);
          //alert(this.Antag);
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetCycleActivity2(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
    //alert(ReceipientActorCode);
    //alert(TransferDateNew);
    return this.CurrentDSAActivityByCycleCodeController.filter(
      function (v, i, d) {

        return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
      }
    )

  }
  CurrentTreatmentCycleActiityMasterController: TreatmentCycleActiityMasterController[];
  ActivityCodeInfo: TreatmentCycleActiityMasterController;
  CurrentIvfCycleActivityMasterRequest: IvfCycleActivityMasterRequest;

  LoadMasterReq() {

    // alert("ScansData")
    this.CurrentIvfCycleActivityMasterRequest = new IvfCycleActivityMasterRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleActivityMasterRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCycleActiityMasterController();
  }

  GetTreatmentCycleActiityMasterController() {
    // this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    //this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentIvfCycleActivityMasterRequest.ConditionalOperator = 10;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetTreatmentCycleActiityMasterController(this.CurrentIvfCycleActivityMasterRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentTreatmentCycleActiityMasterController = this.ApiResData.Result;
          //alert(this.CurrentTreatmentCycleActiityMasterController.length);
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          this.LoadTestData();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.GetCycleActivity(this.ActorCode, this.ScanDate);

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): TreatmentCycleActiityMasterController[] {
    // alert(ReceipientActorCode);
    //alert(TransferDateNew);
    return this.CurrentTreatmentCycleActiityMasterController.filter(
      function (v, i, d) {

        return v.ActorID == ReceipientActorCode && v.DocDate == TransferDateNew;
      }
    )

  }
  CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
  CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;

  LoadTestData() {
    //alert("ScansData")
    this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleTestByCodeController();
  }

  GetIvfCycleTestByCodeController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentIvfCycleTestByCodeRequest.ActorCode = 0;
    this.CurrentIvfCycleTestByCodeRequest.ConditionalOperator = 20;
    this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;
    // alert(this.CurrentIvfCycleTestByCodeRequest.ActivityCode);
    this.ActivityCodenew = this.CurrentIvfCycleTestByCodeRequest.ActivityCode;
    this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          this.LoadMedicineData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfCycleMedicineByCodeController: IvfCycleMedicineByCodeController[];
  CurrentIvfCycleMedicineByCodeRequest: IvfCycleMedicineByCodeRequest;

  LoadMedicineData() {
    //alert("ScansData")
    this.CurrentIvfCycleMedicineByCodeRequest = new IvfCycleMedicineByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleMedicineByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleMedicineByCodeController();
  }

  GetIvfCycleMedicineByCodeController() {
    // this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentIvfCycleMedicineByCodeRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentIvfCycleMedicineByCodeRequest.ConditionalOperator = 20;
    this.CurrentIvfCycleMedicineByCodeRequest.ActorCode = 0;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;
    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleMedicineByCodeController(this.CurrentIvfCycleMedicineByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleMedicineByCodeController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentIvfCycleEmbryoTransferredController: IvfCycleEmbryoTransferredController[];
  CurrentIvfCycleEmbryoTransferredRequest: IvfCycleEmbryoTransferredRequest;

  LoadDropletEmbryoData() {
    //alert("ScansData")
    this.CurrentIvfCycleEmbryoTransferredRequest = new IvfCycleEmbryoTransferredRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleEmbryoTransferredRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleEmbryoTransferredController();
  }

  GetIvfCycleEmbryoTransferredController() {
    // this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentIvfCycleEmbryoTransferredRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentIvfCycleEmbryoTransferredRequest.ConditionalOperator = 10;
    // this.CurrentIvfCycleMedicineByCodeRequest.ActorCode = 0;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    // this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;
    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleEmbryoTransferredController(this.CurrentIvfCycleEmbryoTransferredRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleEmbryoTransferredController = this.ApiResData.Result;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }



  AddTests() {
    const modalRef = this.modalService.open(NgbAddScanTestModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false

      })
    modalRef.componentInstance.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;
    //alert(modalRef.componentInstance.ActivityCode);
    modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    modalRef.componentInstance.ActorCode1 = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
    modalRef.componentInstance.TestCode = this.CurrentIvfCycleTestByCodeController[0].TestCode;

    modalRef.result.then(x => { this.GetIvfCycleTestByCodeController() })
  }
  AddMedicine() {
    const modalRef = this.modalService.open(NgbAddScanMedicineModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false

      })
    modalRef.componentInstance.Typeofscreen = 'Et';
    modalRef.componentInstance.TcModelName = this.ActorDetails.TCModelName;
    modalRef.componentInstance.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;
    modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    modalRef.componentInstance.ActorCode1 = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
    modalRef.componentInstance.MedicineCode = this.CurrentIvfCycleMedicineByCodeController[0].MedicineCode;
    modalRef.componentInstance.ClinicalOrderItem = this.CurrentIvfCycleMedicineByCodeController[0].ClinicalOrderItem;
    modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
  }
  EditTest(l: IvfCycleTestByCodeController) {

    this.CurrentSaveIvfCycleTestDataRequest.ActorCode = l.ActorCode;
    this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;
    this.CurrentSaveIvfCycleTestDataRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveIvfCycleTestDataRequest.CycleTestCode = l.ItemCode;
    this.CurrentSaveIvfCycleTestDataRequest.ClinicalOrderItem = l.ClinicalOrderItem;
    this.CurrentSaveIvfCycleTestDataRequest.TestCode = l.ItemCode;
    this.CurrentSaveIvfCycleTestDataRequest.TestName = l.TestName;
    this.CurrentSaveIvfCycleTestDataRequest.Remarks = l.Comments;
    this.CurrentSaveIvfCycleTestDataRequest.TestDate = l.TestDate;
    this.CurrentSaveIvfCycleTestDataRequest.TestObservation = 0;
    this.CurrentSaveIvfCycleTestDataRequest.Result = l.Result;
    this.CurrentSaveIvfCycleTestDataRequest.ResultUnits = l.ResultUnits;

    const modalRef = this.modalService.open(NgbEditScanTestModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false

      })
    modalRef.componentInstance.CurrentSaveIvfCycleTestDataRequest = this.CurrentSaveIvfCycleTestDataRequest;
    modalRef.result.then(x => { this.GetIvfCycleTestByCodeController() })
    //modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    //modalRef.componentInstance.ActorCode = this.SelectedpatientDetails.ActorID;
    //modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
  }
  EditMedicine(l: IvfCycleMedicineByCodeController) {
    this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = l.ActorCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = l.CycleActivity;
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.StartDate = l.StartDate;
    this.CurrentSaveIvfCycleMedicineDataRequest.EndDate = l.EndDate;
    this.CurrentSaveIvfCycleMedicineDataRequest.ClinicalOrderItem = l.ClinicalOrderItem;
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode = l.CycleMedicineCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 20;
    this.CurrentSaveIvfCycleMedicineDataRequest.Objective = l.Objective;
    this.CurrentSaveIvfCycleMedicineDataRequest.Dose = l.Dosage;
    this.CurrentSaveIvfCycleMedicineDataRequest.DurationType = l.DurationType;
    this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 20;
    this.CurrentSaveIvfCycleMedicineDataRequest.Form = l.DosageForm;
    this.CurrentSaveIvfCycleMedicineDataRequest.Instructions = l.MedicineInstructions;
    this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = l.MedicineCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.MedicineName = l.MedicineName;
    this.CurrentSaveIvfCycleMedicineDataRequest.RecordStatus = l.RecordStatus;
    this.CurrentSaveIvfCycleMedicineDataRequest.Remarks = l.MedicineInstructions;

    //this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode
    //this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = this.ActivityCode;

    //this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = this.ActorCode1;
    //this.CurrentSaveIvfCycleMedicineDataRequest.ClinicalOrderItem = this.ClinicalOrderItem;
    //this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = this.MedicineCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.Duration = l.Duration;
    //this.CurrentSaveIvfCycleMedicineDataRequest.DurationType = "normal";



    const modalRef = this.modalService.open(NgbEditScanMedicineModal,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false

      })
    //modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    //modalRef.componentInstance.ActorCode = this.SelectedpatientDetails.ActorID;
    //modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
    modalRef.componentInstance.CurrentSaveIvfCycleMedicineDataRequest = this.CurrentSaveIvfCycleMedicineDataRequest;
    modalRef.componentInstance.TcModelName = this.ActorDetails.TCModelName;
    modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
  }
  //Addactivity() {
  //    const modalRef = this.modalService.open(NgbEditGradingetModal,
  //        {
  //            centered: true

  //        })

  //}
  delTEST(l: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentitiesTest(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentitiesTest(l: any) {
    var item = l as IvfCycleTestByCodeController;



    console.log('..................');
    // this.StartRefreshing();
    this.CurrentSaveIvfCycleTestDataRequest.ConditionalOperator = 30;
    this.CurrentSaveIvfCycleTestDataRequest.TestCode = item.TestCode;
    this.CurrentSaveIvfCycleTestDataRequest.CycleTestCode = item.ItemCode;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;
    this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;
    this.CurrentSaveIvfCycleTestDataRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentSaveIvfCycleTestDataRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
    //this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);

    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveIvfCycleTestData(this.CurrentSaveIvfCycleTestDataRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            //this.ShowList = true;
            //this.LoadOvaryData();
            this.LoadTestData();
            //this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  delMedicine(l: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentitiesMedicine(l: any) {
    var item2 = l as IvfCycleMedicineByCodeController;

    console.log('..................');
    // this.StartRefreshing();
    this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 30;

    this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = item2.MedicineCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode = item2.CycleMedicineCode;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;;
    this.CurrentSaveIvfCycleMedicineDataRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentSaveIvfCycleTestDataRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
    //this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);

    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveIvfCycleMedicineData(this.CurrentSaveIvfCycleMedicineDataRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            //this.ShowList = true;
            this.LoadMedicineData();

            //this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  GetMaxGrade(l: SingleWellCultureByCycleCodeController): string {
    if (l.Grade6 != null) {
      return l.Grade6
    }
    else if (l.Grade5 != null) {
      return l.Grade5
    }
    else if (l.Grade4 != null) {
      return l.Grade4
    }
    else if (l.Grade3 != null) {
      return l.Grade3
    }
    else if (l.Grade2 != null) {
      return l.Grade2
    }
    else if (l.Grade1 != null) {
      return l.Grade1
    }
    return "";

  }
  GetMaxDOC(l: SingleWellCultureByCycleCodeController): number {
    if (l.DOC1 != null) {
      return l.DOC1
    }
    else if (l.DOC2 != null) {
      return l.DOC2
    }
    else if (l.DOC3 != null) {
      return l.DOC3
    }
    else if (l.DOC4 != null) {
      return l.DOC4
    }
    else if (l.DOC5 != null) {
      return l.DOC5
    }
    else if (l.DOC6 != null) {
      return l.DOC6
    }
    return 0;

  }
  onAssignedToActorCodesurgeon(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      //this.CurrentSaveIvfEmbryoTransferAttemptRequest.Surgeon = event;
      this.CurrentSaveIvfEmbryoTransferAttemptRequest.SurgeonName = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  onAssignedToActorCodeAsstSurgeon(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      // this.CurrentSaveIvfEmbryoTransferAttemptRequest.AsstSurgeon = event;
      //alert(this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon);
      this.CurrentSaveIvfEmbryoTransferAttemptRequest.AsstSurgeonName = event;
      this.CurrentSaveIvfEmbryoTransferAttemptRequest.EmbryologistName = event;
      // console.log('event--_>' + event);
      //   }
    }

  }

  onAssignedToActorCodeAsstSurgeon2(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      // this.CurrentSaveIvfEmbryoTransferAttemptRequest.AsstSurgeon = event;
      //alert(this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon);
      // this.CurrentSaveIvfEmbryoTransferAttemptRequest.AsstSurgeonName = event;
      // this.CurrentSaveIvfEmbryoTransferAttemptRequest.Embryologist = event;
      this.CurrentSaveIvfEmbryoTransferAttemptRequest.EmbryologistName = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  onAssignedToActorCodeAnaesthetist(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      // this.CurrentSaveIvfEmbryoTransferAttemptRequest.Anesthesiologist = event;
      this.CurrentSaveIvfEmbryoTransferAttemptRequest.AnesthesiologistName = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  onSubmit() {
    this.spinner.show();
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndDate = new Date(this.parserFormatter.format(this.TransferEndDate));
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndTime = this.EmbryoTransFerEndInfo.TransferEndTime;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferDate = new Date(this.parserFormatter.format(this.TransferEndDate));
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferStartTime = new Date(this.parserFormatter.format(this.TransferEndDate));
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.AttemptNo = this.EmbryoTransFerEndInfo.AttemptNo;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.Doc = this.EmbryoTransFerEndInfo.Doc;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActualTime = this.FollicularPickupEndInfo.OvumPickupTime;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;

    this.CurrentSaveIvfEmbryoTransferAttemptRequest.ConditionalOperator = 1;
    this.actorservice.SaveIvfEmbryoTransferAttempt(this.CurrentSaveIvfEmbryoTransferAttemptRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();

            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {


            alert(this.ApiResData.ErrorData);


          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


  }
  onSubmitTeam() {
    this.spinner.show();
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.Surgeon = this.EmbryoTransFerEndInfo.Surgeon;
    //this.CurrentSaveFollicularPickupsDetailV2Request.SurgeonName = this.FollicularPickupEndInfo.SurgeonName;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.AsstSurgeon = this.EmbryoTransFerEndInfo.AsstSurgeon;
    //this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeonName = this.FollicularPickupEndInfo.AsstSurgeonName;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.Anesthesiologist = this.EmbryoTransFerEndInfo.Anesthesiologist;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.Embryologist = this.EmbryoTransFerEndInfo.Embryologist;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.AnaesthesiaType = this.EmbryoTransFerEndInfo.AnaesthesiaType;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndDate = new Date(this.parserFormatter.format(this.TransferEndDate));
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndTime = new Date();
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferDate = this.EmbryoTransFerEndInfo.TransferDate;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferStartTime = this.EmbryoTransFerEndInfo.TransferStartTime;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActualTime = this.FollicularPickupEndInfo.OvumPickupTime;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
    //this.C
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.AttemptNo = this.EmbryoTransFerEndInfo.AttemptNo;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.Doc = this.EmbryoTransFerEndInfo.Doc;

    this.CurrentSaveIvfEmbryoTransferAttemptRequest.ConditionalOperator = 2;
    this.actorservice.SaveIvfEmbryoTransferAttempt(this.CurrentSaveIvfEmbryoTransferAttemptRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();

            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {


            alert(this.ApiResData.ErrorData);


          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


  }
  onSubmitTransferDetails() {
    this.spinner.show();
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.EndometriumThickness = this.EmbryoTransFerEndInfo.EndometriumThickness;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.EndometriumThicknessUnit = this.EmbryoTransFerEndInfo.EndometriumThicknessUnit;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.Ultrasound = this.EmbryoTransFerEndInfo.Ultrasound;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferProcess = this.EmbryoTransFerEndInfo.TransferProcess;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.ProcessComments = this.EmbryoTransFerEndInfo.ProcessComments;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.Remarks = this.EmbryoTransFerEndInfo.Remarks;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferStage = this.EmbryoTransFerEndInfo.TransferStage;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.CultureMedia = this.EmbryoTransFerEndInfo.CultureMedia;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferMethod = this.EmbryoTransFerEndInfo.TransferMethod;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.CatheterType = this.EmbryoTransFerEndInfo.CatheterType;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.Catheter = this.EmbryoTransFerEndInfo.Catheter;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.Speculum = this.EmbryoTransFerEndInfo.Speculum;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.Speculum = this.EmbryoTransFerEndInfo.Speculum;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.CervicalCleaning = this.EmbryoTransFerEndInfo.CervicalCleaning;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.HasRetainedEmbryos = this.EmbryoTransFerEndInfo.HasRetainedEmbryos;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.HasFragmentation = this.EmbryoTransFerEndInfo.HasFragmentation;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.CervicalMucus = this.EmbryoTransFerEndInfo.CervicalMucus;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.Technique = this.EmbryoTransFerEndInfo.Technique;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.BloodOnCatheter = this.EmbryoTransFerEndInfo.BloodOnCatheter;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.HasRetransfer = this.EmbryoTransFerEndInfo.HasRetransfer;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferType = this.EmbryoTransFerEndInfo.TransferType;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.Fragmentation = this.EmbryoTransFerEndInfo.Fragmentation;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.ThawingMedia = this.EmbryoTransFerEndInfo.ThawingMedia;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.AnaesthesiaType=

    this.CurrentSaveIvfEmbryoTransferAttemptRequest.DayofCycle = this.EmbryoTransFerEndInfo.DayofCycle;

    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndDate = new Date(this.parserFormatter.format(this.TransferEndDate));
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndTime = new Date();
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferDate = this.EmbryoTransFerEndInfo.TransferDate;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferStartTime = this.EmbryoTransFerEndInfo.TransferStartTime;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActualTime = this.FollicularPickupEndInfo.OvumPickupTime;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
    //this.C
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.AttemptNo = this.EmbryoTransFerEndInfo.AttemptNo;
      this.CurrentSaveIvfEmbryoTransferAttemptRequest.Doc = this.EmbryoTransFerEndInfo.Doc;
      this.CurrentSaveIvfEmbryoTransferAttemptRequest.TypeOfTransfer = this.EmbryoTransFerEndInfo.TypeOfTransfer;
      this.CurrentSaveIvfEmbryoTransferAttemptRequest.DayOfTransfer = this.EmbryoTransFerEndInfo.DayOfTransfer;
      this.CurrentSaveIvfEmbryoTransferAttemptRequest.HasStilette = this.EmbryoTransFerEndInfo.HasStilette;
      this.CurrentSaveIvfEmbryoTransferAttemptRequest.HasDilator = this.EmbryoTransFerEndInfo.HasDilator;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.ConditionalOperator = 3;
    this.actorservice.SaveIvfEmbryoTransferAttempt(this.CurrentSaveIvfEmbryoTransferAttemptRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();

            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {


            alert(this.ApiResData.ErrorData);


          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


    }
    onSubmitNotes() {
        this.spinner.show();
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.Surgeon = this.EmbryoTransFerEndInfo.Surgeon;
        //this.CurrentSaveFollicularPickupsDetailV2Request.SurgeonName = this.FollicularPickupEndInfo.SurgeonName;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.AsstSurgeon = this.EmbryoTransFerEndInfo.AsstSurgeon;
        //this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeonName = this.FollicularPickupEndInfo.AsstSurgeonName;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.Anesthesiologist = this.EmbryoTransFerEndInfo.Anesthesiologist;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.Embryologist = this.EmbryoTransFerEndInfo.Embryologist;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.AnaesthesiaType = this.EmbryoTransFerEndInfo.AnaesthesiaType;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndDate = new Date(this.parserFormatter.format(this.TransferEndDate));
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndTime = new Date();
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferDate = this.EmbryoTransFerEndInfo.TransferDate;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferStartTime = this.EmbryoTransFerEndInfo.TransferStartTime;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActualTime = this.FollicularPickupEndInfo.OvumPickupTime;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
        //this.C
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Notes = this.EmbryoTransFerEndInfo.Notes;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.AttemptNo = this.EmbryoTransFerEndInfo.AttemptNo;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Doc = this.EmbryoTransFerEndInfo.Doc;

        this.CurrentSaveIvfEmbryoTransferAttemptRequest.ConditionalOperator = 6;
        this.actorservice.SaveIvfEmbryoTransferAttempt(this.CurrentSaveIvfEmbryoTransferAttemptRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {

                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();

                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {


                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );


    }
  SaveTransfered(l: SingleWellCultureByCycleCodeController) {



    this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.AttemptNo = this.EmbryoTransFerEndInfo.AttemptNo;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.Doc = this.EmbryoTransFerEndInfo.Doc;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.SingleWellCultureCode = l.SingleWellCultureCode;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.IsTransferred = true;
    this.CurrentSaveIvfEmbryoTransferAttemptRequest.ConditionalOperator = 4;
    this.actorservice.SaveIvfEmbryoTransferAttempt(this.CurrentSaveIvfEmbryoTransferAttemptRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.LoadSingle();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {


            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );


  }
  dataChanged(newobj) {

    this._GetReadyForTransferBetweenDateController();
  }
  _GetReadyForTransferBetweenDateController() {
    this.StartRefreshing();
    this.CurrentReadyForTransferBetweenDateRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentReadyForTransferBetweenDateRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));

    this.actorservice.GetReadyForTransferBetweenDateController(this.CurrentReadyForTransferBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentReadyForTransferBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentReadyForTransferBetweenDateController;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  DecrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetReadyForTransferBetweenDateController();
    //ind++;
  }
  IncrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetReadyForTransferBetweenDateController();
    //ind++;
  }

  Addactivity() {
    const modalRef = this.modalService.open(NgbEditGradingetModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false

      })
    modalRef.componentInstance.Cyclenumber = this.SelectedpatientDetails.TreatmentCycleCode;

    modalRef.componentInstance.ActorCode = this.ActorDetails.RecepientActorCode;
    modalRef.componentInstance.EggSourceType = this.ActorDetails.EggSourceType;
    modalRef.componentInstance.EggActorCode = this.ActorDetails.EggActorCode;
    modalRef.result.then(x => { this.GetIvfCycleEmbryoTransferredController() })
    // modalRef.componentInstance.model = "Add";
  }
  EmbryoTransfer() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.IsTransferCompeted();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  IsTransferCompeted() {


    console.log('..................');
    //this.StartRefreshing();
    this.CurrentSaveCycleStatusRequest.ConditionalOperator = 70;

    this.CurrentSaveCycleStatusRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveCycleStatusRequest.ActivityName = "Embryo Transfer";
    this.CurrentSaveCycleStatusRequest.ActivityStatus = "Completed";
    this.CurrentSaveCycleStatusRequest.Remarks = "None";
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveCycleStatus(this.CurrentSaveCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.LoadCycles();
            //this.LoadScansData();
            //this.LoadOvaryData();
            //this.LoadTestData();
            //this.LoadMedicineData();
            //this.ShowList = true;
            //this.LoadMedicineData();

            //this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
  EmbryoTransferData: TreatmentCycleStatusController[];
  EmbryoTransferData2: TreatmentCycleStatusController;
  CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
  LoadCycles() {
    this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetTreatmentCycleStatusController();
  }

  GetTreatmentCycleStatusController() {
    //this.StartRefreshing();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
          this.EmbryoTransferData = this.ApiResData.Result;
          var embryotransferlist = this.EmbryoTransferData.filter(
            function (g) {
              return g.PhaseActivity == "Embryo Transfer";
            });
          this.EmbryoTransferData = embryotransferlist;
          this.EmbryoTransferData2 = this.EmbryoTransferData[0];
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  BackTodashboard() {
    //this.Showivf = true;
    //this.Showpickup = false;
    this.router.navigate(['healins/ivfworkbench']);
  }
  BackTodashboard2() {
    this.router.navigate(['healins/ivfworkbench']);
  }
  BackToPatientdata() {
    this.displayPatientdata = true;
    this.displayscansdata = false;
  }

  printtransfer() {
    this.printService.printDocument("embryotransfer",
      {
        TreatmentCycleCodedata: this.SelectedpatientDetails.TreatmentCycleCode, Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate,
        Surgeon: this.EmbryoTransFerEndInfo.SurgeonName, AsstSurgeon: this.EmbryoTransFerEndInfo.AsstSurgeonName, Embryologist: this.EmbryoTransFerEndInfo.EmbryologistName, Anaesthesiologist: this.EmbryoTransFerEndInfo.AnesthesiologistName, Anaesthesia: this.EmbryoTransFerEndInfo.AnaesthesiaType, PlannedTime: this.EmbryoTransFerEndInfo.TransferStartTime, ActualDate: this.EmbryoTransFerEndInfo.TransferDate, ActualTime: this.EmbryoTransFerEndInfo.TransferEndTime,
        Doc: this.EmbryoTransFerEndInfo.Doc, CultureMedia: this.EmbryoTransFerEndInfo.CultureMedia, Method: this.EmbryoTransFerEndInfo.TransferMethod, CatheterType: this.EmbryoTransFerEndInfo.CatheterType, CatheterUsed: this.EmbryoTransFerEndInfo.Catheter, SpeculumUsed: this.EmbryoTransFerEndInfo.Speculum, CervicalCleaning: this.EmbryoTransFerEndInfo.CervicalCleaning, RetainedEmbryos: this.EmbryoTransFerEndInfo.HasRetainedEmbryos,
        TransferDatenew: this.EmbryoTransFerEndInfo.TransferDate, ActivityCodenew: this.ActivityCodenew, ActorCode: this.ActorCode, Fragmentation: this.EmbryoTransFerEndInfo.Fragmentation, CervicalMucus: this.EmbryoTransFerEndInfo.CervicalMucus, Technique: this.EmbryoTransFerEndInfo.Technique, BloodOnCatheter: this.EmbryoTransFerEndInfo.BloodOnCatheter, Retransfer: this.EmbryoTransFerEndInfo.HasRetransfer, EmbryoTransfer: this.EmbryoTransFerEndInfo.TransferType,
        DSADOC: this.DSADetails.DOC, DSASTIMULATION: this.DSADetails.STIMULATION, DSAANTAG: this.DSADetails.ANTAG,
      }
    );
  }

  printtransferdroplet() {
    this.printService.printDocument2(this.SelectedpatientDetails.OwnerFormattedCode, 0

    );
    this.printService.printDocument("embryotransferdroplet",
      {
        TreatmentCycleCodedata: this.SelectedpatientDetails.TreatmentCycleCode, Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate,
        Surgeon: this.EmbryoTransFerEndInfo.SurgeonName, AsstSurgeon: this.EmbryoTransFerEndInfo.AsstSurgeonName, Embryologist: this.EmbryoTransFerEndInfo.EmbryologistName, Anaesthesiologist: this.EmbryoTransFerEndInfo.AnesthesiologistName, Anaesthesia: this.EmbryoTransFerEndInfo.AnaesthesiaType, PlannedTime: this.EmbryoTransFerEndInfo.TransferStartTime, ActualDate: this.EmbryoTransFerEndInfo.TransferDate, ActualTime: this.EmbryoTransFerEndInfo.TransferEndTime,
        Doc: this.EmbryoTransFerEndInfo.Doc, CultureMedia: this.EmbryoTransFerEndInfo.CultureMedia, ThawingMedia: this.EmbryoTransFerEndInfo.ThawingMedia, Method: this.EmbryoTransFerEndInfo.TransferMethod, CatheterType: this.EmbryoTransFerEndInfo.CatheterType, CatheterUsed: this.EmbryoTransFerEndInfo.Catheter, SpeculumUsed: this.EmbryoTransFerEndInfo.Speculum, CervicalCleaning: this.EmbryoTransFerEndInfo.CervicalCleaning, RetainedEmbryos: this.EmbryoTransFerEndInfo.HasRetainedEmbryos,
        TransferDatenew: this.EmbryoTransFerEndInfo.TransferDate, ActivityCodenew: this.ActivityCodenew, ActorCode: this.ActorCode, Fragmentation: this.EmbryoTransFerEndInfo.Fragmentation, CervicalMucus: this.EmbryoTransFerEndInfo.CervicalMucus, Technique: this.EmbryoTransFerEndInfo.Technique, BloodOnCatheter: this.EmbryoTransFerEndInfo.BloodOnCatheter, Retransfer: this.EmbryoTransFerEndInfo.HasRetransfer, EmbryoTransfer: this.EmbryoTransFerEndInfo.TransferType,
        EggSourceData: this.ActorDetails.EggSourceType, DonorData: this.ActorDetails.EggName, DonorCode: this.ActorDetails.EggFormattedCode, DSADOC: this.DSADetails.DOC, DSASTIMULATION: this.DSADetails.STIMULATION, DSAANTAG: this.DSADetails.ANTAG, TypeOfTransfer: this.EmbryoTransFerEndInfo.TypeOfTransfer, DayOfTransfer: this.EmbryoTransFerEndInfo.DayOfTransfer, HasStilette: this.EmbryoTransFerEndInfo.HasStilette, HasDilator: this.EmbryoTransFerEndInfo.HasDilator, Notes: this.EmbryoTransFerEndInfo.Notes,
      }
    );
  }
}
